import { services as s } from "@/services";
import { ExtendedProfileT, RoleKeyT } from "@/types/database/profiles";

import { PageT } from "../app/navigation-content";

export const filterAppNavigation = (
    navigationContent: PageT[],
    roles: RoleKeyT[],
    profile: ExtendedProfileT,
    userLabelNames: string[] = []
) => {
    const filtered = navigationContent
        .filter((page) => s.hasCommonElements(page.roles, roles))
        .filter((page) => !(page?.super_user_only === true && profile?.is_super_user === false))
        .filter((page) => {
            if (!page.labels || page.labels.length === 0) return true;
            return s.hasCommonElements(page.labels, userLabelNames);
        });
    return filtered;
};
